import axios, { AxiosRequestConfig } from 'axios'
import { apiUrl } from '.'

export interface APIResponse<D> {
    data?: D
    message?: string
    error?: string
}

const api = axios.create({ baseURL: apiUrl })

export const getAxiosRequestConfig = (token: string): AxiosRequestConfig => {
    return {
        headers: {
            'auth-token': token
        }
    }
}

export default api